import { apiService } from "../services/api.service";
import Moment from "moment";
import { authenticationService } from "../services/authentication.service";

export const toolsController = {
    kontrolaNastaveniaPredajne,
    opravaNastaveniaPredajne,
    vytvorenieSpravyAvizo,
    kontrolaSpravy,
    getInformacie,
    getAkceTrvani,
    getNahlasenieNegenerovaneSpravy,
    generovatNahlasenieSpravy,
    getTextNegenerovaneSpravy,
    generovatTextSpravy,
    getExpediciaNegenerovaneSpravy,
    generovatExpediciaSpravy,
    getAvizoNegenerovaneSpravy,
    generovatAvizoSpravy,
    vytvorenieUzivatelov,
    getUzivateliaZoznam,
    setUzivatelStatus,
    getOdoslanieBalikyExpedovaneParcelItems
};

function kontrolaNastaveniaPredajne() {
    return apiService.fetchApiRequest("api/Tools/KontrolaNastaveniaPredajne");
}

function opravaNastaveniaPredajne() {
    return apiService.fetchApiRequest("api/Tools/OpravaNastaveniaPredajne");
}

function vytvorenieSpravyAvizo() {
    return apiService.fetchApiRequest("api/Tools/VytvorenieSpravyAvizo");
}

function kontrolaSpravy() {
    return apiService.fetchApiRequest("api/Tools/KontrolaSpravy");
}

function getInformacie() {
    return apiService.fetchApiRequest("api/Tools/GetInformacie");
}

function getAkceTrvani(nazev, logger) {
    return apiService.fetchApiRequest(`api/Tools/GetAkceTrvani?nazev=${nazev}&logger=${logger}`);
}

function getNahlasenieNegenerovaneSpravy() {
    return apiService.fetchApiRequest("api/Tools/GetNahlasenieNegenerovaneSpravy");
}

function generovatNahlasenieSpravy(selectedItemIds) {
    var selectedItemIdsQueryString = `selectedItemIds=${selectedItemIds.join("&selectedItemIds=")}`;
    return apiService.fetchApiRequest(`api/Tools/GenerovatNahlasenieSpravy?${selectedItemIdsQueryString}`);
}

function getTextNegenerovaneSpravy() {
    return apiService.fetchApiRequest("api/Tools/GetTextNegenerovaneSpravy");
}

function generovatTextSpravy(selectedItemIds) {
    var selectedItemIdsQueryString = `selectedItemIds=${selectedItemIds.join("&selectedItemIds=")}`;
    return apiService.fetchApiRequest(`api/Tools/GenerovatTextSpravy?${selectedItemIdsQueryString}`);
}

function getExpediciaNegenerovaneSpravy() {
    return apiService.fetchApiRequest("api/Tools/GetExpediciaNegenerovaneSpravy");
}

function generovatExpediciaSpravy(selectedItemIds) {
    var selectedItemIdsQueryString = `selectedItemIds=${selectedItemIds.join("&selectedItemIds=")}`;
    return apiService.fetchApiRequest(`api/Tools/GenerovatExpediciaSpravy?${selectedItemIdsQueryString}`);
}

function getAvizoNegenerovaneSpravy() {
    return apiService.fetchApiRequest("api/Tools/GetAvizoNegenerovaneSpravy");
}

function generovatAvizoSpravy(selectedItemIds) {
    var selectedItemIdsQueryString = `selectedItemIds=${selectedItemIds.join("&selectedItemIds=")}`;
    return apiService.fetchApiRequest(`api/Tools/GenerovatAvizoSpravy?${selectedItemIdsQueryString}`);
}

function vytvorenieUzivatelov(uzivatel) {
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(uzivatel)
    };
    return apiService.fetchApiRequest("api/Tools/VytvorenieUzivatelov", true, requestOptions);
}

function getUzivateliaZoznam() {
    return apiService.fetchApiRequest(`api/Tools/GetUzivateliaZoznam`);
}

function setUzivatelStatus(uzivatel) {
    const currentUser = authenticationService.currentUserValue;

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify(uzivatel)
    };
    return apiService.fetchApiRequest("api/Tools/SetUzivatelStatus", true, requestOptions);
}

function getOdoslanieBalikyExpedovaneParcelItems(filter) {
    var parameters = "";
    if (filter) {
        filter.filters.forEach((element) => {
            if (element.field.indexOf("datum") >= 0) {
                parameters += element.field + "=" + Moment(element.value).format("YYYY-MM-DD") + "&";
            } else parameters += element.field + "=" + element.value + "&";
        });
    }

    return apiService.fetchApiRequest(`api/Tools/GetOdoslanieBalikyExpedovaneParcelItems?` + parameters);
}



// WEBPACK FOOTER //
// ./src/controllers/tools.controller.js